module.exports = __webpack_public_path__ + "static/media/propic5.689add40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/about/propic5.jpg
// module id = 43
// module chunks = 0